module.exports = __webpack_public_path__ + "img/selection.601b65c5.svg";